export const initialPagination: Pagination = {
  page: 1,
  last_page: 1,
  per_page: 100,
  search: "",
  total: 0,
  from: 1,
  to: 25
};
